export type ProjectCard = {
  id: number;
  title: string;
  summary: string;
  description: string;
  cost: number;
  materialCost: number;
  slug: string;
  image: string;
  addedOn: string | null;
};

export type ProjectsResponse = {
  filters: {
    query: string;
  };
  projects: ProjectCard[];
  meta: {
    totalProjects: number;
  };
};

export type ProjectDetailResponse = {
  project: ProjectCard;
  related: ProjectCard[];
};

async function parseResponse(response: Response) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export function projectPath(slug: string, id: number) {
  return `/projects/${encodeURIComponent(slug)}/${id}`;
}

export async function fetchProjects(query: URLSearchParams) {
  const response = await fetch(`/api/projects?${query.toString()}`, {
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as ProjectsResponse;
}

export async function fetchProjectDetail(query: URLSearchParams) {
  const response = await fetch(`/api/projects/detail?${query.toString()}`, {
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as ProjectDetailResponse;
}
